import React from 'react';

const VOLTAGE_TABLE = [
  { v: 4.20, pct: 100 },
  { v: 4.15, pct: 95 },
  { v: 4.10, pct: 87 },
  { v: 4.00, pct: 75 },
  { v: 3.90, pct: 60 },
  { v: 3.80, pct: 40 },
  { v: 3.70, pct: 20 },
  { v: 3.50, pct: 5 },
  { v: 3.30, pct: 0 },
];

const VALID_MIN = 2.5;
const VALID_MAX = 4.5;

export function voltageToPercent(voltage: string | number | null | undefined): number | null {
  if (voltage == null) return null;
  const v = Number(voltage);
  if (isNaN(v) || v < VALID_MIN || v > VALID_MAX) return null;
  if (v >= 4.20) return 100;
  if (v <= 3.30) return 0;

  for (let i = 0; i < VOLTAGE_TABLE.length - 1; i++) {
    const upper = VOLTAGE_TABLE[i];
    const lower = VOLTAGE_TABLE[i + 1];
    if (v <= upper.v && v >= lower.v) {
      const ratio = (v - lower.v) / (upper.v - lower.v);
      return Math.round(lower.pct + ratio * (upper.pct - lower.pct));
    }
  }
  return null;
}

export const BatteryBar: React.FC<{ voltage: string | number | null | undefined }> = ({ voltage }) => {
  const pct = voltageToPercent(voltage);
  if (pct == null) return (
    <div style={{ width: '100%', padding: '0 4px' }}>
      <div style={{
        position: 'relative',
        width: '100%',
        height: 22,
        backgroundColor: '#e0e0e0',
        borderRadius: 4,
        overflow: 'hidden',
      }}>
        <span style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 600,
          color: '#333',
        }}>
          Offline
        </span>
      </div>
    </div>
  );

  const isOffline = pct < 10;
  const isLow = pct < 20;
  const barColor = isOffline ? '#9E9E9E' : isLow ? '#E87722' : pct < 60 ? '#9E9E9E' : '#008490';
  const label = isOffline ? 'Offline' : isLow ? 'Low' : `${pct}%`;

  return (
    <div style={{ width: '100%', padding: '0 4px' }}>
      <div style={{
        position: 'relative',
        width: '100%',
        height: 22,
        backgroundColor: '#e0e0e0',
        borderRadius: 4,
        overflow: 'hidden',
      }}>
        <div style={{
          width: `${pct}%`,
          height: '100%',
          backgroundColor: barColor,
          borderRadius: 4,
          transition: 'width 0.3s ease',
        }} />
        <span style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 600,
          color: pct >= 40 ? '#fff' : '#333',
        }}>
          {label}
        </span>
      </div>
    </div>
  );
};
